export const selectAccessToken = (state) => state.auth.accessToken;
export const selectRefreshToken = (state) => state.auth.refreshToken;
export const selectExpiresAt = (state) => state.auth.expiresAt;
export const selectIsAuthenticated = (state) => Boolean(state.auth.accessToken);
